export default __webpack_public_path__ + "static/media/Review-Integrations.71079a9d.svg";